import { OfficeTab } from '@root/globalTypes';

export const BOTTOM_NAV_CLASS = 'bottom-nav';
export const BOTTOM_NAV_SLOTS = 3;
export const BOTTOM_NAV_PRIMARY: OfficeTab[] = ['hotSeat', 'workload', 'jobs'];
export const BOTTOM_NAV_JOB_ROUTE_PREFIX = 'projects/';
